import { Outlet } from 'react-router-dom';
import Header from '../components/CommonComps/Header';
import ApplicationNavbar from '../components/CommonComps/Navbars/ApplicationNavbar';

const ApplicationLayout = () => {
  // rendering application layout component here
  return (
    <>
      <Header isApplicationPage />

      <main className='font-lato pt-28 mb-10 space-y-10'>
        <ApplicationNavbar />

        <Outlet />
      </main>
    </>
  );
};

export default ApplicationLayout;
